<template>
  <q-page padding>
    <form-events-incident
      v-model="controle"
      :type-incident="$options.EVENTS_MAIN_TYPE_SPECIFIC_CONTROL"
    />
  </q-page>
</template>

<script>
import FormEventsIncident from 'components/forms/Events/FormEventsIncident'
import { EVENTS_MAIN_TYPE_SPECIFIC_CONTROL } from '@/consts/events'

export default {
  name: 'ControleSpecifique',
  EVENTS_MAIN_TYPE_SPECIFIC_CONTROL,
  components: { FormEventsIncident },
  data () {
    return {
      controle: {}
    }
  }
}
</script>

<style scoped>

</style>
